<h1 matDialogTitle>
  {{ 'Extend Vdev' | translate }}
</h1>

<form class="ix-form-container" [formGroup]="form" (submit)="onSubmit($event)">
  <ix-combobox
    formControlName="newDisk"
    [label]="'New Disk' | translate"
    [required]="true"
    [provider]="disksProvider"
    [tooltip]="helptext.dialogFormFields.new_disk.tooltip | translate"
  ></ix-combobox>

  <ix-form-actions>
    <button mat-button type="button" ixTest="cancel" [matDialogClose]="false">
      {{ 'Cancel' | translate }}
    </button>
    <button
      mat-button
      type="submit"
      color="primary"
      ixTest="extend"
      [disabled]="form.invalid"
    >
      {{ 'Extend' | translate }}
    </button>
  </ix-form-actions>
</form>
